import { CustomFieldAnswer } from '@oolio-group/domain';

export const getCustomFieldLines = (answers: CustomFieldAnswer[] = []) =>
  answers.map(({ docketName, value }) => `${docketName}: ${value}`);

export const buildDocketNote = (
  notes: string | undefined,
  answers: CustomFieldAnswer[] | undefined,
) => [notes, ...getCustomFieldLines(answers)].filter(Boolean).join(' | ');
